import {TEST_CALLS_DIALER as PREFIX} from '../../const';
import {generateId} from '../../utils/helpers';
import {DEFAULT_PER_PAGE_DIALER} from '../../const';

const initialState = {
    loading: false,
    test_calls_list: [],
    more: false,
    count: 0,
    page: 1,
    per_page: DEFAULT_PER_PAGE_DIALER
};


const handlers = {
    ['SET_ITEMS_' + PREFIX]: (state, {payload: {
        cdr_full_test_list = [], cdr_full_test_count = 0, cdr_full_test_more = false, page, per_page
    }}) => ({
        ...state,
        test_calls_list: [
            ...cdr_full_test_list.map(x => {
                x.id = generateId();
                return x;
            })
        ],
        loading: false,
        count: cdr_full_test_count,
        more: cdr_full_test_more,
        page,
        per_page
    }),
    ['SET_LOADING_' + PREFIX]: (state, {payload}) => ({...state, loading: payload}),
    DEFAULT: state => state
};

export default (state = initialState, action) => {
    const handle = handlers[action.type] || handlers.DEFAULT;
    return handle(state, action);
};
